import { Controller } from '@hotwired/stimulus';
// @ts-ignore
import Rails from '@rails/ujs';
import { z } from 'zod';
import { isEmpty } from '../shipping_address/utils';
/*
 * Description
 * -------
 *
 * Validates the exit survey form.
 * Must be used on form element.
 * Can be used multiple times in the document.
 *
 * Usage
 * -------
 *
 * <form data-controller="form-exit-survey">
 *   <div data-form-exit-survey-target="error"></div>
 * </form>
 */
export default class default_1 extends Controller {
    static targets = ['error'];
    validateForm() {
        const formValidation = z
            .object({
            reasons: z.array(z.string()).default([]),
            other: z.boolean().optional(),
            other_reason: z.string().trim().optional(),
        })
            .partial()
            .superRefine((data, ctx) => {
            if (data.other && isEmpty(data.other_reason)) {
                ctx.addIssue({
                    code: 'custom',
                    message: 'Please provide other reason',
                    path: ['other_reason'],
                });
            }
        })
            .superRefine((data, ctx) => {
            if (!data.other && data.reasons?.length === 0) {
                ctx.addIssue({
                    code: 'custom',
                    message: 'You should select at least one reason',
                    path: ['reasons'],
                });
            }
        });
        const formValues = Object.fromEntries(new FormData(this.element));
        if (formValues.wants_to_receive_benefits === 'false') {
            return true;
        }
        const values = {
            reasons: Object.keys(formValues).filter((key) => key.startsWith('reasons')),
            other: !!formValues.other,
            other_reason: formValues.other_reason,
        };
        const result = formValidation.safeParse(values);
        if (result.success) {
            this.errorTarget.innerHTML = '';
            return true;
        }
        if (!result.success) {
            const fieldErrors = z.treeifyError(result.error);
            const errors = {};
            Object.keys(fieldErrors.properties || {}).forEach((field) => {
                errors[field] =
                    fieldErrors.properties?.[field]?.errors[0];
            });
            Object.keys(values).forEach((field) => {
                const inputErrorElement = this.errorTarget;
                if (errors[field]) {
                    inputErrorElement.innerHTML = errors[field];
                }
            });
            return false;
        }
    }
    handleSubmit() {
        this.submitCount = this.submitCount ? this.submitCount + 1 : 1;
        const isValid = this.validateForm();
        if (isValid)
            this.submitForm();
    }
    handleChange() {
        if (this.submitCount && this.submitCount > 0) {
            this.validateForm();
        }
    }
    submitForm() {
        Rails.fire(this.element, 'submit');
    }
}
